import { render, staticRenderFns } from "./SrInvoiceHubForm.vue?vue&type=template&id=5ac8c178&"
import script from "./SrInvoiceHubForm.vue?vue&type=script&lang=js&"
export * from "./SrInvoiceHubForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports